/** @jsx jsx */
import { jsx } from '@emotion/core';
import { FunctionComponent, MouseEvent, ReactElement } from 'react';
import * as styles from './styles';

export interface IFormRowProps {
  onClick?: (e: MouseEvent<HTMLElement>) => void;
}

jsx;

export const ViewAction: FunctionComponent<IFormRowProps> = ({ onClick }): ReactElement<IFormRowProps> => {
  return <button css={styles.viewAction} onClick={onClick} />;
};

export default ViewAction;
